'use client';

import { useEffect, useState } from 'react';

import { Box, BoxProps, Typography } from '@mui/material';

const dateOptions = {
  weekday: 'long' as const,
  year: 'numeric' as const,
  month: 'long' as const,
  day: 'numeric' as const,
};

type ClockProps = BoxProps;

export const Clock = ({ sx, ...rest }: ClockProps) => {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const tick = () => {
      setDate(new Date());
    };
    const timerID = setInterval(() => tick(), 5000);
    return function cleanup() {
      clearInterval(timerID);
    };
  });

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        ...sx,
      }}
      {...rest}
    >
      <Typography
        variant="h3"
        sx={{
          fontWeight: 500,
          marginRight: '4rem',
          fontSize: '1.75rem',
        }}
      >
        {date.toLocaleDateString('fr-FR', dateOptions).charAt(0).toUpperCase()}
        {date.toLocaleDateString('fr-FR', dateOptions).slice(1)}
      </Typography>
      <Typography
        variant="h2"
        sx={{
          display: 'flex',
          alignItems: 'center',
          fontWeight: 900,
          fontSize: '2.5rem',
          textAlign: 'right',
        }}
      >
        {date.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
        })}
      </Typography>
    </Box>
  );
};
